// tslint:disable-next-line no-unnecessary-class
export class Router {
    // tslint:disable-next-line function-name
    public static hash(): string {
        return document.location.hash.replace('#', '');
    }

    // tslint:disable-next-line function-name
    public static get(): string {
        return document.location.search.replace('?', '');
    }

    // tslint:disable-next-line function-name
    public static set(uri: string): void {
        // tslint:disable-next-line no-null-keyword
        window.history.replaceState(null, '', `?${uri}`);
    }
}
